import Skeleton from '@mui/material/Skeleton'
import React from 'react'
import { Col, Row } from 'reactstrap'

const PageLoading = () => {
    return (
        <React.Fragment>
            <Row className="justify-content-between align-items-center mb-4">
                {/* Start aligned */}
                <Col className="d-flex justify-content-start">
                    <div>
                        <Skeleton width="18rem" height="36px" variant="rectangular" />
                        <div className="d-flex flex-column mt-3">
                            <Skeleton width="200px" height="32px" className="mb-3" />
                        </div>
                    </div>
                </Col>

                {/* End aligned */}
                <Col className="d-flex justify-content-end">
                    <div className='d-flex flex-column align-items-end'>
                        <Skeleton width="18rem" height="36px" variant="rectangular" />
                        <div className="d-flex flex-column align-items-end mt-3">
                            <Skeleton width="200px" height="32px" className="mb-3" />
                        </div>
                    </div>
                </Col>
            </Row>
            <Skeleton width="30%" height="36px" variant="rectangular" className="mb-4" />
        </React.Fragment>
    )
}

export default PageLoading